import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navbar from '../components/Navbar';

const LogisticsSettings = () => {
  const [settings, setSettings] = useState({
    standardDeliveryFee: 0,
    freeDeliveryThreshold: 0
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const res = await axios.get('/api/logistics');
      setSettings(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSettings({ ...settings, [e.target.name]: parseFloat(e.target.value) });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setError('');
    
    try {
      const token = localStorage.getItem('token');
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };
      await axios.put('/api/logistics', settings, config);
      setMessage('Logistics settings updated successfully!');
    } catch (err: any) {
      setError(err.response?.data?.message || 'Failed to update settings');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-secondary flex flex-col">
      <Navbar />
      <div className="flex-grow container mx-auto px-4 py-12">
        <div className="max-w-2xl mx-auto bg-white p-8 rounded-lg shadow border border-gray-100">
          <h2 className="text-2xl font-serif font-bold text-primary mb-6">Logistics Configuration</h2>
          
          {message && <div className="bg-green-50 text-green-700 p-3 rounded mb-4 border border-green-100">{message}</div>}
          {error && <div className="bg-red-50 text-red-700 p-3 rounded mb-4 border border-red-100">{error}</div>}
          
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Standard Delivery Fee ($)</label>
              <input type="number" name="standardDeliveryFee" value={settings.standardDeliveryFee} onChange={handleChange} className="w-full border border-gray-300 rounded-md px-3 py-2 focus:ring-primary focus:border-primary" />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Free Delivery Threshold ($)</label>
              <p className="text-xs text-gray-500 mb-2">Orders above this amount will have free delivery.</p>
              <input type="number" name="freeDeliveryThreshold" value={settings.freeDeliveryThreshold} onChange={handleChange} className="w-full border border-gray-300 rounded-md px-3 py-2 focus:ring-primary focus:border-primary" />
            </div>

            <button type="submit" disabled={loading} className="w-full bg-primary text-white py-2 px-4 rounded-md hover:bg-green-800 transition disabled:opacity-50">
              {loading ? 'Saving...' : 'Save Settings'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LogisticsSettings;